export default {
  language: {},
  menu: {
    isOpen: false,
  },
  theme: "light",
}
